export default __webpack_public_path__ + "static/media/Savant's Sash of the Heavens.2950aa60.jpg";